"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteSelect = void 0;
const spinner_1 = require("@pulse-web-ui/spinner");
const react_1 = __importStar(require("react"));
const autocomplete_select_styles_1 = require("./autocomplete-select.styles");
const ArrowDown = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./icons/arrow-down'))));
const ArrowUp = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./icons/arrow-up'))));
const Check = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./icons/check'))));
const AutocompleteSelect = ({ placeholder, options, value, onChange, fieldOnChange, onBlur, ariaLabel, disabled, isLoading, status, label, arrowWidth, testId = 'autocompleteSelect', }) => {
    var _a;
    const [isMount, setIsMount] = (0, react_1.useState)(false);
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [inputValue, setInputValue] = (0, react_1.useState)((_a = options === null || options === void 0 ? void 0 : options.find((option) => option.value === value)) === null || _a === void 0 ? void 0 : _a.label);
    const [selectedValue, setSelectedValue] = (0, react_1.useState)(value);
    const [filteredOptions, setFilteredOptions] = (0, react_1.useState)(options);
    const handleInputChange = (val) => {
        if (isOpen) {
            if (!(inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) && !val) {
                setFilteredOptions(options);
            }
            else {
                setFilteredOptions(options === null || options === void 0 ? void 0 : options.filter(({ label }) => label.toLowerCase().includes(val.toLowerCase())));
            }
            setInputValue(val);
        }
    };
    (0, react_1.useEffect)(() => {
        var _a;
        if (JSON.stringify(options) !== JSON.stringify(filteredOptions)) {
            setFilteredOptions(options);
            setInputValue((_a = options === null || options === void 0 ? void 0 : options.find((option) => option.value === value)) === null || _a === void 0 ? void 0 : _a.label);
        }
    }, [options]);
    (0, react_1.useEffect)(() => {
        if (value !== selectedValue) {
            onChange && onChange(selectedValue);
        }
    }, [selectedValue]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (value !== selectedValue) {
            setSelectedValue(value);
            setInputValue((_a = options === null || options === void 0 ? void 0 : options.find((option) => option.value === value)) === null || _a === void 0 ? void 0 : _a.label);
        }
    }, [value]);
    (0, react_1.useEffect)(() => {
        setIsMount(true);
    }, []);
    (0, react_1.useEffect)(() => {
        var _a;
        if (!isOpen && isMount) {
            if (!(inputValue === null || inputValue === void 0 ? void 0 : inputValue.length)) {
                setSelectedValue(undefined);
            }
            else if (options === null || options === void 0 ? void 0 : options.some(({ label }) => label === inputValue)) {
                setSelectedValue((_a = options === null || options === void 0 ? void 0 : options.find((option) => option.label === inputValue)) === null || _a === void 0 ? void 0 : _a.value);
            }
        }
    }, [isOpen]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (!isOpen && !!selectedValue) {
            const newInputValue = (_a = options === null || options === void 0 ? void 0 : options.find((option) => option.value === selectedValue)) === null || _a === void 0 ? void 0 : _a.label;
            if (inputValue !== newInputValue) {
                setInputValue(newInputValue);
            }
            setFilteredOptions(options);
        }
    }, [isOpen, selectedValue, inputValue]);
    (0, react_1.useEffect)(() => {
        if (!isOpen && !!inputValue && !selectedValue) {
            setInputValue('');
            setFilteredOptions(options);
        }
    }, [isOpen, inputValue, selectedValue]);
    return (react_1.default.createElement(autocomplete_select_styles_1.StyledAutocompleteSelect, { "aria-labelledby": ariaLabel || '', onClick: () => !disabled && !isLoading && setIsOpen(!isOpen), onBlur: () => setIsOpen(false), tabIndex: 1 },
        react_1.default.createElement(autocomplete_select_styles_1.StyledAutocompleteInput, { value: inputValue || '', label: label, placeholder: placeholder, onChange: (value) => {
                !disabled && !isLoading && handleInputChange(value);
                fieldOnChange && fieldOnChange(value);
            }, onBlur: (event) => {
                event.stopPropagation();
                setTimeout(() => {
                    setIsOpen(false);
                }, 200);
                onBlur && onBlur(event);
            }, onClick: (event) => {
                if (!disabled && !isLoading && !isOpen) {
                    setIsOpen(true);
                }
                event.stopPropagation();
            }, error: status === 'error', disabled: disabled, "data-testid": `${testId}.input` }),
        react_1.default.createElement(autocomplete_select_styles_1.StyledAutocompleteSelectArrow, { width: arrowWidth, disabled: disabled || isLoading }, isLoading ? (react_1.default.createElement(spinner_1.Spinner, null)) : (react_1.default.createElement(autocomplete_select_styles_1.StyledAutocompleteSelectArrowWrapper, null,
            react_1.default.createElement(react_1.Suspense, { fallback: null }, isOpen ? react_1.default.createElement(ArrowUp, null) : react_1.default.createElement(ArrowDown, null))))),
        react_1.default.createElement(autocomplete_select_styles_1.StyledAutocompleteSelectPopover, null, isOpen && (react_1.default.createElement(autocomplete_select_styles_1.StyledAutocompleteSelectList, null, (filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) ? (filteredOptions.map((option) => (react_1.default.createElement(autocomplete_select_styles_1.StyledAutocompleteSelectOption, { key: `${option.label}_${option.value}`, onClick: () => {
                setInputValue(option.label);
                setSelectedValue(option.value);
            }, "data-testid": `${testId}.option.${option.value}`, isSelected: option.value === value },
            react_1.default.createElement("span", null, option.label),
            value && option.value === value && (react_1.default.createElement(react_1.Suspense, { fallback: null },
                react_1.default.createElement(Check, null))))))) : (react_1.default.createElement(autocomplete_select_styles_1.StyledAutocompleteEmptySelectOption, null, "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E")))))));
};
exports.AutocompleteSelect = AutocompleteSelect;
